import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as SaRecoucesActions from './sa-resources.actions';
import { initialState } from './sa-resources.state';
export const saResourceFeatureKey = 'SaRESOURCE';

export const reducer = createReducer(
  initialState,

  on(SaRecoucesActions.loadResouceRtoOverSuccess, (state, { resRto }) => ({
    ...state,
    resRto,
  }))
);
